//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import showcaseQuery from '~/apollo/queries/product/showcase-slug'

export default {
  mixins: [seo],
  apollo: {
    showcase: {
      prefetch: true,
      query: showcaseQuery,
      variables () {
        return { id: this.$route.query.id }
      },
      result ({ data }) {
        this.seoCategory = this.$route.params.catslug
        this.seoTitle = data.showcase.data.attributes.name
      }
    }
  }
}
